module.exports = __webpack_public_path__ + "static/media/mum-kids01.afc3de59.png";